export * from './stud-register.service'; 